
import * as defaultImport from "@splunk/react-ui/Text";
export * from "@splunk/react-ui/Text";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
